import React from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin, Calendar } from "lucide-react";
import { fileUrl, inr } from "@/lib/api";

export default function TourCard({ tour }) {
  return (
    <Link to={`/tours/${tour.slug || tour.id}`} className="group card-warm overflow-hidden flex flex-col" data-testid={`tour-card-${tour.id}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-warm-surface">
        <img src={fileUrl(tour.coverImage)} alt={tour.title}
          className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-700"
          onError={(e)=>{e.currentTarget.style.opacity=0.2;}} />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="bg-white/95 text-maroon text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full">{tour.category}</span>
        </div>
        {tour.featured && (
          <span className="absolute top-3 right-3 bg-amber-500 text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full">Featured</span>
        )}
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center gap-3 text-sm text-slate-500 mb-2">
          <span className="inline-flex items-center gap-1"><MapPin size={14} /> {tour.region}</span>
          <span className="inline-flex items-center gap-1"><Clock size={14} /> {tour.durationDays} days</span>
        </div>
        {tour.types?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-2" data-testid={`tour-types-${tour.id}`}>
            {tour.types.map((tp) => (
              <span key={tp} className="text-[11px] font-semibold bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full">{tp}</span>
            ))}
          </div>
        )}
        <h3 className="font-display text-xl font-bold text-maroon leading-snug mb-3 group-hover:text-amber-700 transition">
          {tour.title}
        </h3>
        <p className="text-slate-600 text-[15px] leading-relaxed line-clamp-3 flex-1">{tour.overview}</p>
        <div className="mt-4 flex items-end justify-between border-t border-amber-900/10 pt-4">
          <div>
            <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold">Starting from</div>
            <div className="text-2xl font-bold text-maroon font-display">{inr(tour.startingPrice)}</div>
            <div className="text-xs text-slate-500">per person</div>
          </div>
          <div className="text-right">
            {tour.departureDates?.length > 0 && (
              <div className="inline-flex items-center gap-1 text-sm text-amber-800 font-semibold">
                <Calendar size={14} /> {tour.departureDates.length} dates
              </div>
            )}
            <div className="mt-1 text-amber-700 text-sm font-bold group-hover:underline">View Details →</div>
          </div>
        </div>
      </div>
    </Link>
  );
}
